import React from "react";

function LoginModal({
  loginUser,
  setLoginUser,
  loginPass,
  setLoginPass,
  loading,
  onClose,
  onSubmit,
}) {
  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.8)", display: "flex",
        alignItems: "center", justifyContent: "center", zIndex: 1000
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          backgroundColor: "#171a21",
          padding: "2rem",
          borderRadius: "6px",
          width: "320px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          color: "white"
        }}
      >
        <img
          src="https://store.cloudflare.steamstatic.com/public/shared/images/header/logo_steam.svg"
          alt="Steam logo"
          style={{ width: "120px", margin: "0 auto 1rem" }}
        />
        <input
          type="text"
          placeholder="Steam uživatelské jméno"
          value={loginUser}
          onChange={(e) => setLoginUser(e.target.value)}
          style={{ padding: "0.5rem", borderRadius: "4px", border: "none", backgroundColor: "#2a475e", color: "white" }}
        />
        <input
          type="password"
          placeholder="Heslo"
          value={loginPass}
          onChange={(e) => setLoginPass(e.target.value)}
          style={{ padding: "0.5rem", borderRadius: "4px", border: "none", backgroundColor: "#2a475e", color: "white" }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: "#66c0f4",
            border: "none",
            borderRadius: "4px",
            padding: "0.6rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {loading ? "Přihlašuji..." : "Přihlásit se"}
        </button>
        <button
          type="button"
          onClick={onClose}
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "#66c0f4",
            cursor: "pointer",
            marginTop: "0.5rem",
          }}
        >
          Zrušit
        </button>
      </form>
    </div>
  );
}

export default LoginModal;
